module.exports = __webpack_public_path__ + "media/images/pdf_form/vera-caf2c60de558cbce59888868cea748e4.ttf";